/**
 * @author lifei & gll
 * 模块说明：xxx
 */

import { Service } from '@/tools'
export class AfterSalesReturnService <T extends TOrder.AfterSalesReturn> extends Service {
  constructor(path: string) {
    super()
    this.setPathPrefix(path)
  }

  private post2<P extends TCommon.ApiVersion = 'v1'>(url: `${P}/${keyof TOrder.AfterSalesReturn}`, data?: TCommon.Json, toast?: string) {
    return this.post(url, data, toast)
  }
  
            
  /**
   * 功能：编辑-编辑销售退货单
   */
  updateRefund = (data: T['ApiUpdateRefund']['req']): Promise<T['ApiUpdateRefund']['res']> => this.post2('v1/ApiUpdateRefund', data)
            
  /**
   * 功能：批发团购-查询可退商品
   */
  selectProductAddList = (data: T['ApiSelectProductAddList']['req']): Promise<T['ApiSelectProductAddList']['res']> => this.post2('v1/ApiSelectProductAddList', data)

  /**
   * 功能：新增-添加商品
   */
  queryProduct = (data: T['ApiQueryProduct']['req']): Promise<T['ApiQueryProduct']['res']> => this.post2('v1/ApiQueryProduct', data)

  /**
   * 功能：详情-分页查询退货单商品列表
   */
  productList = (data: T['ApiProductList']['req']): Promise<T['ApiProductList']['res']> => this.post2('v1/ApiProductList', data)
            
  /**
   * 功能：列表-分页查询退货单列表
   */
  page = (data: T['ApiPage']['req']): Promise<T['ApiPage']['res']> => this.post2('v1/ApiPage', data)
            
  /**
   * 功能：详情-查询退货单详情物流列表
   */
  logisticsList = (data: T['ApiLogisticsList']['req']): Promise<T['ApiLogisticsList']['res']> => this.post2('v1/ApiLogisticsList', data)
            
  /**
   * 功能：销售退货单导出
   */
  export = (data: T['ApiExport']['req']): Promise<T['ApiExport']['res']> => this.post2('v1/ApiExport', data, 'blob')
            
  /**
   * 功能：详情-了结销售退货单
   */
  endRefund = (data: T['ApiEndRefund']['req']): Promise<T['ApiEndRefund']['res']> => this.post2('v1/ApiEndRefund', data)
         
   /**
   * 功能：详情-下推单据
   */
  pushDelivery = (data: T['ApiPushDelivery']['req']): Promise<T['ApiPushDelivery']['res']> => this.post2('v1/ApiPushDelivery', data)
     
  /**
   * 功能：详情-查询退货单列表详情
   */
  detail = (data: T['ApiDetail']['req']): Promise<T['ApiDetail']['res']> => this.post2('v1/ApiDetail', data)
            
  /**
   * 功能：销售退货单关闭
   */
  close = (data: T['ApiClose']['req']): Promise<T['ApiClose']['res']> => this.post2('v1/ApiClose', data)
            
  /**
   * 功能：新增-新增销售退货单
   */
  addRefund = (data: T['ApiAddRefund']['req']): Promise<T['ApiAddRefund']['res']> => this.post2('v1/ApiAddRefund', data)
            
  /**
   * 功能：新增-导入商品
   */
  importProduct = (data: T['ApiImportProduct']['req']): Promise<T['ApiImportProduct']['res']> => this.post2('v1/ApiImportProduct', data)
            
  /**
   * 功能：销退订单-审批
   */
  orderRefundApproval = (data: T['ApiOrderRefundApproval']['req']): Promise<T['ApiOrderRefundApproval']['res']> => this.post2('v1/ApiOrderRefundApproval', data)

    /**
   * 功能：销退订单-审批
   */
  selectProductPage = (data: T['ApiSelectProductPage']['req']): Promise<T['ApiSelectProductPage']['res']> => this.post2('v1/ApiSelectProductPage', data)
}
